import {ThemeMode, ThemeStyle} from '../../../../shared/constants/AppEnums';
import styled from 'styled-components';

export const BoxContainer = styled.div`
  ${({themeStyle, themeMode, theme}) => `
  max-height: 100vh;
  height: 100%;
      padding-left: ${themeStyle === ThemeStyle.MODERN ? 30 : 0}px;
      padding-top: ${themeStyle === ThemeStyle.MODERN ? 30 : 0}px;
      padding-bottom: ${themeStyle === ThemeStyle.MODERN ? 30 : 0}px;
      width: ${themeStyle === ThemeStyle.MODERN ? '19rem' : '19rem'};
      ${theme.breakpoints.up('xl')} {
        width: ${themeStyle === ThemeStyle.MODERN ? '22.8rem' : '21.6rem'};
      }
      
      & .sidebar-bg {
      overflow: hidden;
      background-color:
        ${
          themeMode === ThemeMode.SEMI_DARK
            ? theme.palette.sidebar.bgColor
            : themeMode === ThemeMode.LIGHT
            ? 'white'
            : '#313541'
        };
    }
    
    & .sidebar-modern {
      height: 100%;
      width: 100%;
      color: white;
      overflow: hidden;
      border-radius: 30px;
    }
    
    & .sidebar-standard {
      height: 100%;
      width: 100%;
      color: white;
      overflow: hidden;
    }
    
    & .scrollAppSidebar {
      padding-top: 8px;
      padding-bottom: 8px;
      height:
        ${
          themeStyle === ThemeStyle.MODERN
            ? 'calc(100vh - 166px) !important'
            : 'calc(100vh - 116px) !important'
        };
      ${theme.breakpoints.up('xl')} {
        height:
          ${
            themeStyle === ThemeStyle.MODERN
              ? 'calc(100vh - 190px) !important'
              : 'calc(100vh - 130px) !important'
          };
      }
    }
 `}
`;

export const DrawerContainer = styled.div`
  ${({themeStyle, themeMode, theme}) => `
      max-height: 100vh;
      height: 100%;
      padding-left: 0;
      padding-top: 0;
      padding-bottom: 0;
      width: 19rem;
      ${theme.breakpoints.up('xl')} {
        width: 21.6rem;
      }
      
      & .sidebar-bg {
          overflow: hidden;
          background-color:
            ${
              themeMode === ThemeMode.SEMI_DARK
                ? theme.palette.sidebar.bgColor
                : themeMode === ThemeMode.LIGHT
                ? 'white'
                : '#313541'
            };
      }
      
      & .drawer-scroll-appSidebar {
          padding-top: 8px;
          padding-bottom: 20px;
          height: 'calc(100vh - 58px) !important';
      }
 `}
`;
